import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import tours from "../../datebase/tours";

import "./home.css"
import { Link, useParams } from "react-router-dom";
const Home = ({ t, langcat, Swiper, SwiperSlide, Navigation, Pagination, Mousewheel, Autoplay, setThemeLogo }) => {
    const slides = [
        {
            image: "/home-fon1.png",
            title: t("hometext2-1"),
            theme: true
        },
        {
            image: "/home-fon2.png",
            title: t("hometext2-2"),
            theme: true
        },
        {
            image: "/home-fon3.png",
            title: t("hometext2-3"),
            theme: true
        },
        {
            image: "/home-fon4.png",
            title: t("hometext2-4"),
            theme: false
        },
    ];
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        setThemeLogo(slides[currentSlide].theme);
    }, [currentSlide]);

    return (
        <>
            {slides.map((slide, index) => (
                <img
                    key={index}
                    src={slide.image}
                    alt={`slide-${index}`}
                    className={`home-bg-image ${currentSlide === index ? "active" : ""
                        }`}
                />
            ))}
            {/* <div className="video-background">
                <video autoPlay muted loop className="video-bg">
                    <source src="/home-fon1.mp4" type="video/mp4" />
                </video>
            </div> */}
            <section className="home">
                <div className="container">
                    <div className="home-flex">
                        <span className="home-flex-texts">
                            <h2>{slides[currentSlide].title}</h2>
                            <h3>{t(`hometext3`)}</h3>
                        </span>
                        {/* <span className="home-flex-btns">
                            <Link to={"/tours"} className="home-flex-btn1">{t(`viewtours`)}</Link>
                            <a href="#video" className="home-flex-btn2">
                                <i class="fa fa-play" aria-hidden="true"></i>
                            </a>
                            <span className="home-flex-btn2-text">{t(`playvideo`)}</span>
                        </span> */}
                    </div>
                </div>
            </section>
            <section className="section-2">
                <div className="container">
                    <div className="sec-2-flex">
                        <div className="sec-1-textbox">
                            <h2>{t(`sec-2-text2`)}</h2>
                            <h1>{t(`sec-2-text1`)}</h1>
                        </div>
                        <Swiper
                            className="homeSwiper"
                            modules={[Navigation, Pagination, Mousewheel, Autoplay]}
                            spaceBetween={20}
                            slidesPerView={3}
                            navigation={{
                                nextEl: '.swiper-button-next-custom',
                                prevEl: '.swiper-button-prev-custom',
                            }}
                            pagination={{ clickable: true }}
                            mousewheel
                            grabCursor
                            loop={true} // 🔁 делает слайды бесконечными
                            autoplay={{
                                delay: 3000, // ⏱ задержка между сменой слайдов (в мс)
                                disableOnInteraction: false, // 👆 продолжает после ручного скролла
                            }}
                            breakpoints={{
                                320: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                1024: { slidesPerView: 3 },
                            }}
                        >
                            <div className="swiper-button-prev-custom"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                            <div className="swiper-button-next-custom"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                            {tours.map((koks) => {
                                if (koks.tourlang === langcat && koks.id >= 1) {
                                    return (
                                        <SwiperSlide key={koks.id}>
                                            <Link
                                                className="link"
                                                to={`/tours/${koks.id}`}

                                            >
                                                <div className="sec-2-box">
                                                    <div className="sec-2-box-img">
                                                        <img src={`${koks.img[0]}.jpg`} alt={koks.name} />
                                                    </div>
                                                    <div className="sec-2-box-texts">
                                                        <h5>{koks.name}</h5>
                                                        <span className="sec-2-box-text-box">
                                                            <span className="sec-2-box-text-price">
                                                                <h2>{t("from")}</h2>
                                                                <i className="fa fa-usd" aria-hidden="true"></i>
                                                                <h3>{koks.price}</h3>
                                                            </span>
                                                            <span className="sec-2-box-text-duration">
                                                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                                                                <h5>{koks.dayDuration}</h5>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </SwiperSlide>
                                    );
                                }
                                return null;
                            })}
                        </Swiper>
                    </div>
                </div>
            </section>
            <section className="section-3">
                <div className="container">
                    <div className="sec-3-flex">
                        <div className="sec-3-flex-box1">
                            <div className="sec-3-flex-box1-text">
                                <h5>{t("sec-3-flex-box1-text1")}</h5>
                                <h2>{t("sec-3-flex-box1-text2")}</h2>
                            </div>
                            <div className="sec-3-flex-box1-step">
                                <div className="sec-3-flex-box1-step-boxs">
                                    <span className="sec-3-flex-box1-step-boxs-icon sec-3-flex-box1-step-boxs-icon1">
                                        <img src="othericon/step_icon1.png" alt="" />
                                    </span>
                                    <span className="sec-3-flex-box1-step-boxs-text">
                                        <h5>{t("sec-3-flex-box1-step-boxs-text1-1")}</h5>
                                        <h3>{t("sec-3-flex-box1-step-boxs-text1-2")}</h3>
                                    </span>
                                </div>
                                <div className="sec-3-flex-box1-step-boxs">
                                    <span className="sec-3-flex-box1-step-boxs-icon sec-3-flex-box1-step-boxs-icon2">
                                        <img src="othericon/step_icon2.png" alt="" />
                                    </span>
                                    <span className="sec-3-flex-box1-step-boxs-text">
                                        <h5>{t("sec-3-flex-box1-step-boxs-text2-1")}</h5>
                                        <h3>{t("sec-3-flex-box1-step-boxs-text2-2")}</h3>
                                    </span>
                                </div>
                                <div className="sec-3-flex-box1-step-boxs">
                                    <span className="sec-3-flex-box1-step-boxs-icon sec-3-flex-box1-step-boxs-icon3">
                                        <img src="othericon/step_icon3.png" alt="" />
                                    </span>
                                    <span className="sec-3-flex-box1-step-boxs-text">
                                        <h5>{t("sec-3-flex-box1-step-boxs-text3-1")}</h5>
                                        <h3>{t("sec-3-flex-box1-step-boxs-text3-2")}</h3>
                                    </span>
                                </div>
                                <div className="sec-3-flex-box1-step-boxs">
                                    <span className="sec-3-flex-box1-step-boxs-icon sec-3-flex-box1-step-boxs-icon4">
                                        <img src="othericon/step_icon4.png" alt="" />
                                    </span>
                                    <span className="sec-3-flex-box1-step-boxs-text">
                                        <h5>{t("sec-3-flex-box1-step-boxs-text4-1")}</h5>
                                        <h3>{t("sec-3-flex-box1-step-boxs-text4-2")}</h3>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="sec-3-flex-box2">
                            <span>
                                <img src="othericon/bandicam.gif" alt="" />
                            </span>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-4" id="video">
                <div className="container">
                    <div className="sec-4-flex" >
                        <div className="sec-4-flex-box1">
                            <h4 className="sec-4-flex-box1-h4">{t("sec-4-flex-box1-h4")}</h4>
                            <h5 className="sec-4-flex-box1-h5">{t("sec-4-flex-box1-h5")}</h5>
                        </div>
                        <div className="sec-4-flex-box2">
                            <iframe
                                src="https://www.youtube.com/embed/Io1Cj4c8mTE?si=gRxem5Yi2Q9Pfvnh&controls=0&loop=1&playlist=Io1Cj4c8mTE"
                                title="Besqala"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin"
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-1">
                <div className="container">
                    <div className="sec-1-flex">
                        <div className="sec-1-textbox">
                            <h1>{t(`category`)}</h1>
                            <h2>{t(`sec1text`)}</h2>
                        </div>
                        <div className="sec-1-boxs">
                            <div className="sec-1-box">
                                <span><img src="guide.png" alt="" /></span>
                                <h1>{t(`servicebox1-1`)}</h1>
                                <h2>{t(`servicebox1-2`)}</h2>
                            </div>
                            <div className="sec-1-box">
                                <span><img src="transport.png" alt="" /></span>
                                <h1>{t(`servicebox2-1`)}</h1>
                                <h2>{t(`servicebox2-2`)}</h2>
                            </div>
                            <div className="sec-1-box">
                                <span><img src="hotel.png" alt="" /></span>
                                <h1>{t(`servicebox3-1`)}</h1>
                                <h2>{t(`servicebox3-2`)}</h2>
                                <a href="https://www.booking.com/hotel/uz/guest-house-besqala.html?utm_source=chatgpt.com" target="_blank" className="sec-1-box-souvenirs">{t(`servicebox3-3`)}<i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                            </div>
                            <div className="sec-1-box">
                                <span><img src="catering.png" alt="" /></span>
                                <h1>{t(`servicebox4-1`)}</h1>
                                <h2>{t(`servicebox4-2`)}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-5">
                <div className="container">
                    <div className="sec-5-flex">
                        <div className="sec-5-flex-text1">
                            {t("sec-5-flex-text1")}
                        </div>
                        <div className="sec-5-flex-boxs">
                            <a href="https://wa.me/998913777729" target="_blank" className="sec-5-flex-box">Whatsapp</a>
                            <a href="https://t.me/urazaevtima" target="_blank" className="sec-5-flex-box">Telegram</a>
                            <a href="mailto:besqalatour@gmail.com" target="_blank" className="sec-5-flex-box">{t("email")}</a>
                            <Link className="sec-5-flex-box" to={"/support"}>{t("website")}</Link>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
export default Home